/**
 * Created by sange on 15/08/2017.
 */

import { LoginTokenModel } from '../../../../api/identity/models/login-token-model'
import * as Auth from '../actions'

export const initialState: LoginTokenModel = {
  access_token: null,
  refresh_token: null,
  token_type: null,
  expires_in: 0,
}

export function reducer(state = initialState, action: Auth.AuthActions | Auth.UserActions): LoginTokenModel {
  switch (action.type) {
    case Auth.LOGIN_SUCCESS:
    case Auth.REFRESH_TOKEN_SUCCESS: {
      return {...action.payload}
    }

    case Auth.LOGOUT_SUCCESS: {
      return {...initialState}
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/store/reducers/auth.reducer.ts